import { useTheme } from '../theme/ThemeContext';
import { IconMoon, IconSun } from './icons';

export function ThemeToggle() {
  const { scheme, toggle, label } = useTheme();
  // Показываем иконку ЦЕЛИ клика: в светлой — луну (переключить в тёмную), в тёмной — солнце.
  const Icon = scheme === 'light' ? IconMoon : IconSun;
  return (
    <button
      onClick={toggle}
      title={`Тема: ${label}`}
      aria-label={`Сменить тему (сейчас: ${label})`}
      className="inline-flex h-8 w-8 items-center justify-center rounded text-muted hover:bg-panel hover:text-fg transition-colors"
    >
      <Icon size={14} />
    </button>
  );
}
